import { MODELS } from '../Lib/constants';

export const listAllUri = ({ filter = {}, params, navigation } = {}) => {
  let addOnFilter = {};
  const dealerId = navigation?.state?.params?.item?._id;
  if (dealerId) {
    addOnFilter.dealerId = { _id: dealerId };
  }

  return {
    query: {
      id: 'subscriptionHistoryQuery',
      addOnFilter,
    },
    aggregate: true,
    model: MODELS.SubscriptionHistory,
  };
};

export const viewUri = ({ navigation }) => {
  return {
    query: {
      model: MODELS.SubscriptionHistory,
      id: 'subscriptionHistoryQuery',
      relationValue: {
        model: MODELS.SubscriptionHistory,
        _id: navigation?.state?.params?.item?._id,
        relation: '_id',
      },
      limit: 1,
    },
    model: MODELS.SubscriptionHistory,
  };
};
